import { useEffect, useRef, useState } from "react";
import { Card, Table, Form, Row, Col, Dropdown, Button } from "react-bootstrap";
import {
  FiCalendar,
  FiChevronDown,
  FiFileText,
  FiDownload,
  FiTrash2,
} from "react-icons/fi";
import InvoiceModal from "../../modals/dashboard/admin-dashboard/InvoiceModal";
import DeleteModal from "../../modals/dashboard/admin-dashboard/DeleteModal";

// import InvoiceModal from "./InvoiceModal";
// import DeleteModal from "./DeleteModal";
const data = [
  {
    id: "INV001",
    name: "BrightWave Innovations",
    img: "/assets/img/company/company-01.svg",
    email: "[email protected]",
    date: "12 Sep 2024",
    amount: "$200",
    method: "Credit Card",
    status: "Paid",
  },
  {
    id: "INV002",
    name: "Stellar Dynamics",
    img: "/assets/img/company/company-02.svg",
    email: "[email protected]",
    date: "24 Oct 2024",
    amount: "$600",
    method: "Paypal",
    status: "Paid",
  },
  {
    id: "INV003",
    name: "Quantum Nexus",
    img: "/assets/img/company/company-03.svg",
    email: "[email protected]",
    date: "18 Feb 2024",
    amount: "$200",
    method: "Debit Card",
    status: "Paid",
  },
  {
    id: "INV004",
    name: "EcoVision Enterprises",
    img: "/assets/img/company/company-04.svg",
    email: "[email protected]",
    date: "17 Oct 2024",
    amount: "$200",
    method: "Paypal",
    status: "Paid",
  },
  {
    id: "INV005",
    name: "Aurora Technologies",
    img: "/assets/img/company/company-05.svg",
    email: "[email protected]",
    date: "20 Jul 2024",
    amount: "$400",
    method: "Credit Card",
    status: "Paid",
  },
  {
    id: "INV006",
    name: "BlueSky Ventures",
    img: "/assets/img/company/company-06.svg",
    email: "[email protected]",
    date: "10 Apr 2024",
    amount: "$200",
    method: "Paypal",
    status: "Paid",
  },
  {
    id: "INV007",
    name: "TerraFusion Energy",
    img: "/assets/img/company/company-07.svg",
    email: "[email protected]",
    date: "29 Aug 2024",
    amount: "$4800",
    method: "Credit Card",
    status: "Paid",
  },
  {
    id: "INV008",
    name: "UrbanPulse Design",
    img: "/assets/img/company/company-08.svg",
    email: "[email protected]",
    date: "22 Feb 2024",
    amount: "$50",
    method: "Credit Card",
    status: "Unpaid",
  },
  {
    id: "INV009",
    name: "Nimbus Networks",
    img: "/assets/img/company/company-09.svg",
    email: "[email protected]",
    date: "03 Nov 2024",
    amount: "$600",
    method: "Paypal",
    status: "Paid",
  },
  {
    id: "INV010",
    name: "Epicurean Delights",
    img: "/assets/img/company/company-10.svg",
    email: "[email protected]",
    date: "17 Dec 2024",
    amount: "$200",
    method: "Credit Card",
    status: "Paid",
  },
];

export default function PurchaseTransactionList() {
  const [showInvoice, setShowInvoice] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(10);
  const options = [
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "This Year",
    "Next Year",
    "Custom Range",
  ];
  const [transactions, setTransactions] = useState(data);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("Last 7 Days");
  const ref = useRef();

  // close on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (!ref.current?.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  const handleDownload = (row) => {
    const blob = new Blob([JSON.stringify(row, null, 2)], {
      type: "application/json",
    });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${row.id}.json`;
    a.click();
  };
  const filteredDeals = data.filter(
    (item) =>
      item.name.toLowerCase().includes(search.toLowerCase()) ||
      item.id.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <Card className="p-3">
      {/* HEADER */}
      <Row className="align-items-center mb-3">
        <Col md={4}>
          <h5 className="fw-semibold">Transaction List</h5>
        </Col>

        <Col md={8} className="text-md-end">
          <div className="d-flex flex-wrap gap-2 justify-content-md-end">
            {/* DATE */}
            <div className="date-wrapper" ref={ref}>
              {/* Input */}
              <div className="date-box" onClick={() => setOpen(!open)}>
                <FiCalendar />
                <input value="03/30/2026 - 04/05/2026" readOnly />
              </div>

              {/* Dropdown */}
              {open && (
                <div className="date-dropdown text-start">
                  {options.map((item, index) => (
                    <div
                      key={index}
                      className={`date-item ${
                        selected === item ? "active" : ""
                      }`}
                      onClick={() => {
                        setSelected(item);
                        setOpen(false);
                      }}
                    >
                      {item}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* PAYMENT */}
            <Dropdown>
              <Dropdown.Toggle className="filter-box date-box text-dark">
                Payment Method <FiChevronDown size={16} />
              </Dropdown.Toggle>
              <Dropdown.Menu className="custom-dropdown">
                <Dropdown.Item>Credit Card</Dropdown.Item>
                <Dropdown.Item>Paypal</Dropdown.Item>
                <Dropdown.Item>Debit Card</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* STATUS */}
            <Dropdown>
              <Dropdown.Toggle className="filter-box date-box text-dark">
                Select Status <FiChevronDown size={16} />
              </Dropdown.Toggle>
              <Dropdown.Menu className="custom-dropdown">
                <Dropdown.Item>Paid</Dropdown.Item>
                <Dropdown.Item>Unpaid</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* SORT */}
            <Dropdown>
              <Dropdown.Toggle className="filter-box date-box text-dark">
                Sort By : Last 7 Days <FiChevronDown size={16} />
              </Dropdown.Toggle>
              <Dropdown.Menu className="custom-dropdown">
                <Dropdown.Item>Recently Added</Dropdown.Item>
                <Dropdown.Item>Ascending</Dropdown.Item>
                <Dropdown.Item>Descending</Dropdown.Item>
                <Dropdown.Item>Last Month</Dropdown.Item>
                <Dropdown.Item>Last 7 Days</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Col>
      </Row>

      {/* ROW + SEARCH */}
      <Row className="mb-2 align-items-center">
        <Col md={6} className="d-flex align-items-center gap-2">
          <span>Row Per Page</span>
          <Form.Select
            value={rows}
            onChange={(e) => setRows(e.target.value)}
            style={{ width: "80px" }}
          >
            <option>10</option>
            <option>20</option>
          </Form.Select>
          <span>Entries</span>
        </Col>

        <Col md={6} className="text-md-end">
          <Form.Control
            placeholder="Search"
            style={{ maxWidth: "250px", display: "inline-block" }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>
      </Row>

      {/* TABLE */}
      <div className="table-responsive">
        <Table className="align-middle">
          <thead>
            <tr>
              <th>
                <Form.Check />
              </th>
              <th>Invoice ID</th>
              <th>Customer</th>
              <th>Email</th>
              <th>Date</th>
              <th>Amount</th>
              <th>Method</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {data.map((item, i) => (
              <tr key={i}>
                <td>
                  <Form.Check />
                </td>

                <td>{item.id}</td>

                <td>
                  <div className="d-flex align-items-center">
                    <img src={item.img} className="avatar me-2" alt="" />
                    {item.name}
                  </div>
                </td>

                <td>{item.email}</td>
                <td>{item.date}</td>
                <td>{item.amount}</td>
                <td>{item.method}</td>

                <td>
                  <span
                    className={`badge ${
                      item.status === "Paid" ? "bg-success" : "bg-danger"
                    }`}
                  >
                    {item.status}
                  </span>
                </td>

                <td>
                  <div className="d-flex gap-2">
                    <FiFileText
                      className="action-icon"
                      onClick={() => setShowInvoice(true)}
                    />

                    <FiDownload
                      className="action-icon"
                      onClick={() => handleDownload(item)}
                    />

                    <FiTrash2
                      className="action-icon text-danger"
                      onClick={() => {
                        setSelectedItem(item);
                        setShowDelete(true);
                      }}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="deal-footer d-flex justify-content-between align-items-center">
          {/* LEFT TEXT */}
          <small className="text-muted">
            Showing {filteredDeals.length > 0 ? 1 : 0} to{" "}
            {Math.min(rows, filteredDeals.length)} of {filteredDeals.length}{" "}
            entries
          </small>

          {/* RIGHT PAGINATION */}
          <div className="d-flex align-items-center gap-2">
            {/* LEFT ARROW */}
            <span className="page-arrow">‹</span>

            {/* ACTIVE PAGE */}
            <span className="page-number active">1</span>

            {/* RIGHT ARROW */}
            <span className="page-arrow">›</span>
          </div>
        </div>
      </div>

      {/* MODALS */}
      <InvoiceModal show={showInvoice} onHide={() => setShowInvoice(false)} />
      {/* <DeleteModal show={showDelete} onHide={() => setShowDelete(false)} /> */}
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onDelete={() => {
          if (selectedItem) {
            setTransactions((prev) =>
              prev.filter((t) => t.id !== selectedItem.id),
            );
            setShowDelete(false);
            setSelectedItem(null);
          }
        }}
      />

      <style>
        {`
          .filter-box {
  border: 1px solid #e5e7eb;
  padding: 6px 12px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  background: #fff;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.action-icon {
  cursor: pointer;
  font-size: 18px;
}

.table thead {
  background: #f9fafb;
}
  
/* FILTER BOX (buttons) */
.filter-box {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  font-size: 14px;
  color: #111827;
  cursor: pointer;
  white-space: nowrap;
}

/* remove bootstrap default arrow */
.dropdown-toggle::after {
  display: none !important;
}

/* dropdown button spacing */
.dropdown-btn {
  display: flex;
  align-items: center;
  gap: 6px;
}

/* DROPDOWN MENU */
.custom-dropdown {
  border-radius: 10px;
  padding: 6px 0;
  border: 1px solid #eee;
  box-shadow: 0 8px 20px rgba(0,0,0,0.08);
  min-width: 180px;
}

/* DROPDOWN ITEM */
.custom-dropdown .dropdown-item {
  padding: 10px 16px;
  font-size: 14px;
  color: #374151;
  transition: 0.2s;
}

/* hover effect like image */
.custom-dropdown .dropdown-item:hover {
  background-color: #f97316;  /* orange */
  color: #fff;
}

/* active selected item (optional) */
.custom-dropdown .dropdown-item.active {
  background-color: #f97316;
  color: #fff;
}

/* spacing fix for icons */
.filter-box svg {
  font-size: 16px;
  color: #6b7280;
}


/* Wrapper */
.date-wrapper {
  position: relative;
  width: 220px;
}

/* Input box */
.date-box {
  display: flex;
  align-items: center;
  gap: 10px;

  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
  background: #fff;
  cursor: pointer;
}

.date-box svg {
  font-size: 18px;
  color: #374151;
}

.date-box input {
  border: none;
  outline: none;
  font-size: 14px;
  width: 100%;
  color: #111827;
  cursor: pointer;
}

/* Dropdown */
.date-dropdown {
  position: absolute;
  top: 110%;
  left: 0;

  width: 100%;
  background: #fff;

  border: 1px solid #e5e7eb;
  border-radius: 8px;

  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  overflow: hidden;

  z-index: 1000;
}

.date-box:hover,
.date-box:focus,
.date-box:active,
.date-box.show {
  background-color: #fff !important;
  color: #111827 !important;
  box-shadow: none !important;
  border-color: #d1d5db !important;
}
/* Arrow top */
.date-dropdown::before {
  content: "";
  position: absolute;
  top: -6px;
  left: 20px;

  width: 12px;
  height: 12px;
  background: white;

  border-left: 1px solid #e5e7eb;
  border-top: 1px solid #e5e7eb;

  transform: rotate(45deg);
}

/* Items */
.date-item {
  padding: 10px 14px;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
  transition: background 0.2s ease;
}

/* Hover */
.date-item:hover {
  background: #f3f4f6;
}

/* Active (ORANGE) */
.date-item.active {
  background: #f97316;
  color: #fff;
}

/* Mobile */
@media (max-width: 576px) {
  .date-wrapper {
    width: 100%;
  }
}
/* FOOTER CONTAINER */
.deal-footer {
  border-top: 1px solid #e5e7eb;
  padding: 10px 0;
}

/* TEXT */
.deal-footer small {
  font-size: 13px;
  color: #6b7280;
}

/* PAGINATION WRAPPER */
.page-arrow,
.page-number {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  font-size: 14px;
}

/* ARROWS */
.page-arrow {
  color: #9ca3af;
}

/* ACTIVE PAGE (ORANGE CIRCLE) */
.page-number.active {
  background-color: #ff6a00;
  color: #fff;
  font-weight: 500;
}

/* HOVER EFFECT */
.page-arrow:hover {
  background: #f3f4f6;
}
`}
      </style>
    </Card>
  );
}
